export interface PropertySelectionState {
  assignAll: boolean;
  propertyIds: number[];
}

export function toggleSelectAllProperties(
  assignAll: boolean,
  allPropertyIds: number[]
): PropertySelectionState {
  if (assignAll) {
    return {
      assignAll: false,
      propertyIds: [],
    };
  }

  return {
    assignAll: true,
    propertyIds: [...allPropertyIds],
  };
}

export function togglePropertySelection(
  propertyId: number,
  selectedIds: number[],
  assignAll: boolean,
  allPropertyIds: number[]
): PropertySelectionState {
  const currentIds = assignAll ? allPropertyIds : selectedIds;

  if (currentIds.includes(propertyId)) {
    return {
      assignAll: false,
      propertyIds: currentIds.filter((id) => id !== propertyId),
    };
  }

  return {
    assignAll: false,
    propertyIds: [...currentIds, propertyId],
  };
}
